import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Alert } from 'reactstrap'
import AppObject from './AppObject'
import { NEW_OBJECT_QUERY } from '../../graphql.js'

export const NEW_OBJECT = gql(NEW_OBJECT_QUERY)

export default function CreateObject({ match, location }) {

  let objectTypeId = null
  let source = null
  if (match && match.params.id) {
    objectTypeId = match.params.id
    const params = new URLSearchParams(location.search)
    source = params.get('source')
  }

  const { loading, error, data } = useQuery(NEW_OBJECT, { variables: { objectTypeId: objectTypeId } })
  console.log(`CreateObject rendered: objectTypeId: ${objectTypeId} source: ${source}`)

  if (error) {
    console.log(`CreateObject: ${error.message}`)
    return <Alert color="danger">{error.message}</Alert>
  }
  if (loading) {
    return <Spinner />
  }
  if (data) {
    if (data.newObject) {
      // find the SUBMIT action for this object type
      let submitAction
      for (let i = 0; i < data.newObject.type.actions.length; i++) {
        if (data.newObject.type.actions[i].type.name === 'SUBMIT') {
          submitAction = data.newObject.type.actions[i]
          break
        }
      }
      return <AppObject object={data.newObject} action={submitAction} initialSource={source} />
    } else {
      console.log('data: ', data)
      return ''
    }
  }
  return ''
}